import { render } from "./payment-link-modal.vue?vue&type=template&id=495fb1f2"
import script from "./payment-link-modal.vue?vue&type=script&lang=js"
export * from "./payment-link-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__